import { Module } from '../Module';

Module.instance().directive('tbSelected', <any[]>[
  () => {
    return {
      restrict: 'A',
      link: (scope: ng.IScope, element: JQuery, attr: ng.IAttributes) => {
        scope.$watch(attr['tbSelected'], (selected: boolean) => {
          element.toggleClass('tb-selected', selected);
        });
      }
    };
  }
]);
